import { render, staticRenderFns } from "./VaRating.vue?vue&type=template&id=ad5371da&"
import script from "./VaRating.vue?vue&type=script&lang=js&"
export * from "./VaRating.vue?vue&type=script&lang=js&"
import style0 from "./VaRating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports